// Angular
import { Injectable } from '@angular/core';
// RxJS
import { Subject } from 'rxjs';
import { AuthService } from '../../../auth/_services/auth.service';
import { UserModel } from '../../../auth/_models/user.model';
import { MenuConfigType, SingleMenuConfigType, ParentMenuConfigType, SubMenuConfigType, BaseMenuConfigType } from '../../../../core/_config/menu.config';

@Injectable()
export class MenuConfigService {
	// Public properties
	onConfigUpdated$: Subject<any>;
	// Private properties
	private menuConfig: any;

	/**
	 * Service Constructor
	 */
	constructor(
		private _authService: AuthService,
		) {
		// register on config changed event and set default config
		this.onConfigUpdated$ = new Subject();
	}

	/**
	 * Returns the menuConfig
	 */
	getMenus() {
		return this.menuConfig;
	}

	/**
	 * Load config
	 *
	 * @param config: any
	 */
	loadConfigs(config: MenuConfigType) {

		this._authService.currentUser$.subscribe(
			(user) => {
				let availableConfig = this.resolveNavigation(user, config)
				this.menuConfig = availableConfig;
				this.onConfigUpdated$.next(this.menuConfig);
			}
		  );
	}


	private resolveNavigation(user: UserModel, startMenuConfig: MenuConfigType): void {
		// Clear Navigation on User Change (null is considered a change)
	   	// this.resetNavigation();

		if (!user || !user.permissions) {
			return;
		}

		let menu: any = {
			header: {
				self: {},
				items: [
				]
				},
				aside: {
					self: {},
					items: [
					]
					}};

		startMenuConfig.header.items.forEach(element => {
			if ("permissionId" in element) {
				if (
					( !element.permissionId || user.permissions.some(x => x.id == element.permissionId) )
					&& element.page
					&& this.validateUserAttributes(element, user)
				) {
					menu.header.items.push(element);
				}
			}
			else
			{
				var subMenus = element.submenu;
				element.submenu = [];

				if (subMenus  && subMenus.length)
				{
					subMenus.forEach(subMenu => {
						if (
							(!subMenu.permissionId
							|| user.permissions.some(x => x.id == subMenu.permissionId))
							&& this.validateUserAttributes(subMenu, user)
						) {
							element.submenu.push(subMenu);
						}
					});
					if  (element.submenu.length && this.validateUserAttributes(element, user))
					{
						menu.header.items.push(element);
					}
				}
			}
		});
	// 	user.permissions.forEach(p => {
	// 	 const navId = p.id.toString();
	// 	 const item = this._fuseNavigationService.getNavigationItem(navId);
	// 	 if (item) {
	// 	   this.showParent(item);

	// 	   this._fuseNavigationService.updateNavigationItem(navId, {
	// 		 hidden: false
	// 	   });
	// 	 }
	//    });
		return menu;
	 }

	//  private resetNavigation(): void {
	//    const currentNav = this._fuseNavigationService.getNavigation('main');
	//    if (currentNav && currentNav.length) {
	// 	 this._fuseNavigationService.hideAllItems(currentNav, environment.menu.excludedMenuItems);
	//    }
	//  }

	//  private showParent(item: any): void {
	//    const parentItem = this._fuseNavigationService.getNavigationItemParent(item.id);
	//    if (parentItem) {
	// 	 if (parentItem.hidden) {
	// 	   this._fuseNavigationService.updateNavigationItem(parentItem.id, {
	// 		 hidden: false
	// 	   });
	// 	 }
	// 	 this.showParent(parentItem);
	//    }
	//  }

	private validateUserAttributes(item: BaseMenuConfigType, user: UserModel) {
		if (item.userAttributes && item.userAttributes.length) {
			return item.userAttributes.every(config => {
				// If the user attribute check is a function
				if (typeof config == 'function') {
					return config(user);
				} else {
					switch (config.op) {
						case '==':
							return user[config.attr] == config.value;
						case '!=':
							return user[config.attr] != config.value;
						case 'in':
							return (user[config.attr] as any[] || []).some(x => x == config.value)
						case 'in':
							return (user[config.attr] as any[] || []).every(x => x != config.value)
						default:
							break;
					}
				}
			})
		} else {
			return true;
		}
	}
}
